﻿export class PermissionModel{
    isAdd?: boolean = false;
    isEdit?: boolean = false;
    isDel?: boolean = false;
    isMail?: boolean = false;
    isBulk?: boolean = false;
    isView?: boolean = false;
}